// @flow strict

export const RATE_APR_19 = 'APR19'
export const RATE_APR_29 = 'APR29'
export const RATE_APR_39 = 'APR39'
